import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { DCCompanyType } from "src/app/services/companies/companies.service";
import { TabUtilsService } from "src/app/services/tab-utils.service";

@Component({
  selector: "bpc-dc-company-dropdown",
  templateUrl: "./dc-company-dropdown.html",
  styleUrl: "./dc-company-dropdown.scss",
})
export class DcCompanyDropdownComponent implements OnInit {
  allTypes: { name: string; value: DCCompanyType }[] = [];
  selectedTypes: { name: string; value: DCCompanyType }[] = [];
  @Output() onChange = new EventEmitter<number[]>();

  clearFiltersSubscription!: Subscription;

  constructor(
    private tabsUtilsService: TabUtilsService
  ) {}

  ngOnInit(): void {
    this.clearFiltersSubscription = this.tabsUtilsService.clearFilters.subscribe(()=>{
      this.selectedTypes = [];
    });

    this.loadTypes();
    this.onChange.emit(this.selectedTypes.map((type) => type.value));
  }

  ngOnDestroy(): void{
    this.onChange.emit([]);
    if (this.clearFiltersSubscription)
      this.clearFiltersSubscription.unsubscribe();
  }

  loadTypes() {
    this.allTypes = Object.keys(DCCompanyType)
      .filter((key) => isNaN(Number(key))) // Filter out the numeric keys
      .map((key) => ({
        name: key, // Use the key as the name (e.g., "Lender")
        value: DCCompanyType[key as keyof typeof DCCompanyType], // Get the corresponding numeric value
      }));

    const targetOption = this.allTypes.find((type) => type.value === DCCompanyType.Target);
    if (targetOption) {
      this.selectedTypes = [targetOption];
    }
  }

  onTypeChange(multiSelect: any) {
    multiSelect.hide();
    console.log(this.selectedTypes);
    this.onChange.emit(this.selectedTypes.map((type) => type.value));
  }
}
